import { render, staticRenderFns } from "./NotificationToast.vue?vue&type=template&id=4745b83e&scoped=true&"
import script from "./NotificationToast.vue?vue&type=script&lang=js&"
export * from "./NotificationToast.vue?vue&type=script&lang=js&"
import style0 from "./NotificationToast.vue?vue&type=style&index=0&id=4745b83e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4745b83e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
